import { ToolsConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsyncSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
//import { ToolsConfiguration } from "../../models/minisite.model";

@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  private apiRoot = '/api/tools';
  private tools: ToolsConfiguration;
  private tools$: Subject<ToolsConfiguration> = new Subject();
  private asyncSidebar$: AsyncSubject<any> = new AsyncSubject();

  constructor(private http: HttpClient) {}

  public getAll$(): Observable<any> {
    return this.http.get<any>(environment.sitesBuilder.api + `${this.apiRoot}`);
  }
  public getTools$(): Observable<ToolsConfiguration> {
    return this.tools$.asObservable();
  }

  public setTools(tools: ToolsConfiguration): void {
    this.tools = tools;
    this.tools$.next(this.tools);
  }

  public getAsyncTools$(): Observable<ToolsConfiguration> {
    return this.asyncSidebar$.asObservable();
  }
  public setAsyncTools$(tools: ToolsConfiguration): void {
    this.tools = tools;
    this.asyncSidebar$.next(tools);
    this.asyncSidebar$.complete();
  }

  // Edit tools config on workflow by default
  public editDefaultTools(toolsConfig: ToolsConfiguration, workflowId: number): ToolsConfiguration {
    // Fiters
    if (toolsConfig.filters && toolsConfig.filters.enabled && workflowId === 6) {
      // Disable filters on workflow by default for workflow panos only
      toolsConfig.filters.enabled = false;
    }
    // Popups
    if (toolsConfig.popups && toolsConfig.popups.enabled && workflowId === 7) {
      // Disable image on workflows without panos
      toolsConfig.popups.image = false;
    }

    return toolsConfig;
  }
}
